import { useDispatch, useSelector } from 'react-redux'
import PageTopTitle from '../../components/shared/PageTopTitle'
import styled from 'styled-components'
import { useEffect } from 'react'
import {  getWebHesaplama } from '../../features/admin2/admin2Slice'
import moment from 'moment'
import 'moment/locale/tr'
import { useState } from 'react'
import Pagination from '../../components/shared/Pagination'
import { getAracTypes } from '../../features/adminSett/adminSettSlice'

const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
        gap: 60px;
        margin: 0 30px;
        margin-top: 20px;
        .titles{
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
            gap: 20px;
            padding: 15px;
            p{
                font-size: 18px;
                font-weight: 600;
                text-align: center;
            }
        }
        .container{
            .card{
                display: grid;
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
                gap: 20px;
                height: 70px;
                align-items: center;
                background-color: var(--color-light);
                margin-block: 15px;
                padding: 15px;
                border-radius: 10px;
                p{
                    text-align: center;
                }
            }
        }
    }
}
`

const WebMaliyetHesapSonuc = () => {
    const {aracTypes}  = useSelector((state)=> state.adminSett)
    const {webHesaplamaSonuclari, webHesaplamaSonuclariCount} = useSelector((state) => state.admin2)
    const dispatch = useDispatch()

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 20;

    const totalPages = Math.ceil(webHesaplamaSonuclariCount / itemsPerPage);

    useEffect(() => {
        dispatch(getWebHesaplama(currentPage))
    },[dispatch, currentPage])

    useEffect(()=>{
        dispatch(getAracTypes())
    },[])

  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Kamyoon Web Hesaplama Sonuçları"} position='sticky'/>
      <div className="content">
        <div className="titles">
            <p>Telefon</p>
            <p>Tarih</p>
            {/* <p>Mail</p> */}
            <p>Araç</p>
            <p>Nereden</p>
            <p>Nereye</p>
            <p>Tonaj</p>
        </div>

        <div className="container">
            {webHesaplamaSonuclari?.map((item) => {
                const findArac = aracTypes.find(arac => arac.id === item.aracType);
                return(
                <div className="card">
                    <p>{item?.webTelefon || <span>{item?.user?.phoneNumber}<br/>{item?.user?.adSoyadUnvan}</span>}</p>
                    <p>{moment(item.createdOn).format("DD.MM.YYYY")}  {moment(item.createdOn).format('HH:mm:ss')}</p>
                    {/* <p>{item?.webMail || "-"}</p> */}
                    <p>{findArac?.name || "-"}</p>
                    <p>{item?.nereden || "-"}</p>
                    <p>{item?.nereye || "-"}</p>
                    <p>{item?.tonajData || "-"}</p>
                </div>
            )})}
        </div>
      </div>

      {(webHesaplamaSonuclari || webHesaplamaSonuclari?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
    </div>
  </Container>
  )
}

export default WebMaliyetHesapSonuc